
  import ipxRuntime$TRtfqRPQ3HKQ5GolKnO8nVlewoxQzOc7MwyjRoQKEvE from '/app/node_modules/.pnpm/@nuxt+image@2.0.0_db0@0.3.4_drizzle-orm@0.45.2_@opentelemetry+api@1.9.1_@types+pg@8.20._0bb330860f315ad12c40eb6020cf6866/node_modules/@nuxt/image/dist/runtime/providers/ipx'
import cmsIpxRuntime$rtmDfoztmt8dyZhSShETFQxc_MPYLFhA_45Xd_3PPhGAg from '/app/web/app/providers/cms-ipx.ts'
  
  export const imageOptions = {
    ...{
  "screens": {
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "2xl": 1536,
    "xs": 360
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    /** @type {"ipx"} */
    provider: "ipx",
    providers: {
        ['ipx']: { setup: ipxRuntime$TRtfqRPQ3HKQ5GolKnO8nVlewoxQzOc7MwyjRoQKEvE, defaults: {} },
  ['cmsIpx']: { setup: cmsIpxRuntime$rtmDfoztmt8dyZhSShETFQxc_MPYLFhA_45Xd_3PPhGAg, defaults: {} }
    }
  }
